const STORAGE_KEY = "recsys_device_id";

export function deviceId(): string {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored) return stored;
  const minted = crypto.randomUUID();
  sessionStorage.setItem(STORAGE_KEY, minted);
  return minted;
}
